import { render } from "./role_form.vue?vue&type=template&id=6f37af82"
import script from "./role_form.vue?vue&type=script&lang=js"
export * from "./role_form.vue?vue&type=script&lang=js"

import "./role_form.vue?vue&type=style&index=0&id=6f37af82&lang=scss"
script.render = render

export default script